import { render, staticRenderFns } from "./ViewTab.vue?vue&type=template&id=3fdfc71e&scoped=true&"
import script from "./ViewTab.vue?vue&type=script&lang=js&"
export * from "./ViewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdfc71e",
  null
  
)

export default component.exports